import type { EncounterType } from '@pm/graphql';
import { Text } from '@pm/ui';
import { ReactNode } from 'react';
import { AppointmentDuration } from './AppointmentDuration';
import { EncounterTypeDisplay } from './EncounterTypeDisplay';

type AppointmentHeaderProps = {
  heading: string;
  durationInMinutes?: number;
  callProperties: {
    encounterType: EncounterType;
  };
  clinicName?: string;
  children?: ReactNode;
};

export const AppointmentHeader = ({
  heading,
  durationInMinutes,
  callProperties,
  children: error,
  clinicName,
}: AppointmentHeaderProps) => {
  const shouldShowDuration = !!(durationInMinutes && durationInMinutes > 0);

  return (
    <section className="space-y-m border-b border-default pb-l">
      <Text as="h1" size="headingM">
        {heading}
      </Text>
      <div className="space-y-l">
        <div className="flex flex-wrap gap-m">
          {shouldShowDuration && (
            <AppointmentDuration durationInMinutes={durationInMinutes} />
          )}
          <EncounterTypeDisplay
            encounterType={callProperties.encounterType}
            clinicName={clinicName}
          />
        </div>
        {error}
      </div>
    </section>
  );
};
